import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowLeft3 = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 8.121,
	height: 13.414,
	viewBox: "0 0 8.121 13.414",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "Path_10",
		"data-name": "Path 10",
		d: "M2452.765,351l-2,2-4,4,6,6",
		transform: "translate(-2445.351 -350.293)",
		fill: "none",
		stroke: "#999999",
		strokeWidth: 2
	})
});
export default SvgArrowLeft3;
